<template>
  <div class="as-line-ups">
    <div class="as-back-green">
      <div class="as-line-ups-info">
        <div class="as-line-ups-info-item">
          <IconStadium />
          {{ lineups.venue?.name || '--' }}
        </div>
        <div class="as-line-ups-info-item">
          <span>
            {{ getWeatherDetail(lineups.environment?.weather || 0) }}
          </span>
          <span>
            {{ lineups.environment?.temperature || '--' }}
          </span>
        </div>
      </div>
      <div class="as-ground-box">
        <div
          v-if="lineups.home_formation"
          class="as-formation as-formation-home"
        >
          {{ lineups.home_formation }}
        </div>
        <div class="as-mid-circle">
          <div class="as-mid-inner"></div>
        </div>
        <div
          v-for="(team, key) in ['home', 'away']"
          :key="key"
          class="as-w-100 as-half-box"
          :class="{
            'as-half-box-away': team === 'away',
          }"
        >
          <div class="as-square2"><div class="as-square1"></div></div>
          <div class="as-w-100">
            <div class="as-circle"></div>
          </div>
          <div class="as-lineup-players">
            <SquadItem
              :players="
                team === 'home' ? lineupsHomeAway.home : lineupsHomeAway.away
              "
              :teamType="team"
            />
            <SquadItem
              :players="
                team === 'home' ? lineupsHomeAway.home : lineupsHomeAway.away
              "
              screen="sm"
              :teamType="team"
            />
          </div>
        </div>
        <div
          v-if="lineups.away_formation"
          class="as-formation as-formation-away"
        >
          {{ lineups.away_formation }}
        </div>
      </div>
      <!-- <div class="as-team-info as-team-info-away">
        <div class="as-team-name as-w-o-h">
          <span class="as-away-name">{{ lineups.coach.away.name }}</span>
          <span class="as-formation-away as-ml-6">{{ lineups.away_formation }}</span>
        </div>
      </div> -->
    </div>
    <div class="as-note">
      <div
        v-for="(incident, key) in listIncidents"
        :key="key"
        class="as-note-item"
      >
        <component :is="incident.icon" />{{ incident.label }}
      </div>
    </div>
    <h4 class="as-squad-title"><span>Dự bị</span></h4>
    <Players
      :match="match"
      :lineups="lineups"
      :startingPlayers="startingPlayers"
      :isSubstituted="true"
    />
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, computed } from "vue";
import type {
  ILineups,
  IMatch,
  IPlayer,
  IIncidentStatistic,
  IStartingPlayers,
} from "~src/interfaces";
import Players from "~src/components/lineups/Players.vue";
import SquadItem from "~src/components/lineups/SquadItem.vue";;
import MatchEnum from "~src/enums/MatchEnum";
import IconStadium from "~src/components/icons/IconStadium.vue";
import { getWeatherDetail } from "~src/helpers";
interface IProps {
  lineups: ILineups;
  match: IMatch;
  startingPlayers: IStartingPlayers;
}

const props = withDefaults(defineProps<IProps>(), {});

const listIncidents: IIncidentStatistic[] = MatchEnum.INCIDENT_LIST;

const lineupsHomeAway = computed(() => {
  const filterByStatus = (team: IPlayer[]) => {
    return team && Array.isArray(team)
      ? team.filter((player) => player.first === 1)
      : [];
  };
  let home: IPlayer[] = [],
    away: IPlayer[] = [];
  if (props.lineups.id) {
    try {
      home = filterByStatus(props.lineups.lineup.home);
      away = filterByStatus(props.lineups.lineup.away);
    } catch (error) {
      console.error("Error filtering lineups:", error);
    }
  }

  return {
    home,
    away,
  };
});
</script>

<script lang="ts">
export default {};
</script>
